import { useQuery } from '@tanstack/react-query';
import { Response } from 'application/Shared/Helpers';
import { ClientLink } from 'application/Shared/types/clientLink';
import axios from 'axios';

interface ClientLinkGetResponseData {
    data: ClientLink[];
    message: string;
    serverResponse: number;
}

interface ClientLinkGetGlobalAdminPayload {
    platformTenantId?: string;
    linkedTenantId?: string;
    includeTenant?: boolean;
    size?: number;
}

export const useFetchGlobalAdminClientLinks = ({
    params,
    enabled
}: {
    params: ClientLinkGetGlobalAdminPayload;
    enabled: boolean;
}) => {
    const { data, isLoading, refetch } = useQuery<ClientLink[]>({
        enabled,
        queryFn: async () =>
            axios
                .get<ClientLinkGetResponseData>('/clientLink', { params })
                .then((res) => {
                    if (Response.hasData(res)) {
                        return Response.getData(res);
                    }
                    return [];
                }),
        queryKey: ['clientLinks', params]
    });

    return { clientLinks: data, loading: isLoading, refetchData: refetch };
};
